import http from '@/requests/http'

class Slogan {
  static getAllActive (params) {
    return http.post('slogan/active-datas', params)
  }
  static all (params) {
    return http.post('slogan/index', params)
  }
  static async view (params) {
    return http.post('slogan/view', params)
  }
  static async update (data) {
    return http.post('slogan/update', data)
  }
  static async save (data) {
    return http.post('slogan/store', data)
  }
  static async delete (id) {
    return http.post(`slogan/delete/${id}`)
  }
}

export default Slogan
